/**
 * AdminProfile.js — My Account / profile page.
 *
 * Allows logged-in users to view and update their personal details
 * (name, email, mobile, landline, company). Posts changes to the engine API.
 * Protected — redirects to home if not logged in.
 *
 * Props:
 *  - Good {string}                    Time-of-day greeting (e.g. "Good morning").
 *  - UpdateloginUserDetail {object}   Current logged-in user details.
 *  - useLoggedIn {boolean}            Whether the user is authenticated.
 *  - ShowLoginPopup_ {Function}       Opens the login modal.
 *  - UpdateCartQty {Function}         Updates the cart badge.
 *  - UpdateCartAmount {Function}      Updates the cart total.
 *  - EngineURL {string}               Base URL for the engine API.
 */

// ─── External libraries ───────────────────────────────────────────────────────
import React, { useState, useEffect } from "react";

import EditIconImg from "../../images/edit.png";
import PlusIconImg from "../../images/plus.png";
import { Container, Row, Col, Form, Button, InputGroup, Alert } from "react-bootstrap";
import { Helmet } from "react-helmet";
import BlueBg from "../../images/my-profile-banner.png";

import pm from "../../images/pm-new.svg";
import ps from "../../images/ps-new.svg";
import sl from "../../images/sl-new.svg";
import ep from "../../images/ep-new.svg";

import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { AdminSidebar } from "./Sidebar/AdminSidebar";
import axios from "axios";
import { ManuallyCPD } from "../Modals/ManuallyCPD";
import { useLocation } from "react-router-dom";

export const AdminProfile = (props) => {
  const [validated, setValidated] = useState(false);
  const [cpdMixLoading, setCpdMixLoading] = useState(true);

  const stateMap = {
    "Victoria": "VIC",
    "New South Wales": "NSW",
    "Queensland": "QLD",
    "Tasmania": "TAS",
    "Western Australia": "WA",
    "South Australia": "SA",
    "Australian Capital Territory": "ACT",
  };



  /***
   * Query
   */

  /****
   * State Decalration
   */
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [emailAddress, setemailAddress] = useState("");
  const [Company, setCompany] = useState("");
  const [Phone, setPhone] = useState("");
  const [AddressID, setAddressID] = useState("");
  const [CustomerID, setCustomerID] = useState("");
  const [userToken, setUserToken] = useState(undefined);

  const [EditProfile, setEditProfile] = useState(false);

  const [TotalOrder, setTotalOrder] = useState("0");
  const [TotalCPDpoints, setTotalCPDpoints] = useState("0");
  const [PS_points, set_PS_points] = useState("0");
  const [PM_points, set_PM_points] = useState("0");
  const [SL_points, set_SL_points] = useState("0");
  const [EP_points, set_EP_points] = useState("0");
  const [yourReferalCode, setyourReferalCode] = useState(null);

  const PracticeArea = [
    "Building & Construction",
    "Business & Contracts",
    "Consumer",
    "Corporate & In-House Counsel",
    "Costs",
    "Criminal",
    "Employment & Workplace Relations",
    "Ethics",
    "Family",
    "Finance, Tax, Superannuation",
    "Government, Privacy & FOI",
    "Insolvency & Restructuring",
    "Intellectual Property",
    "Legal Practice Fundamentals",
    "Litigation & Advocacy",
    "Migration",
    "Personal Injury & Medico-Legal",
    "Professional Skills & Practice Management",
    "Property, Leases & Planning",
    "Sports Law",
    "Wills, Trusts & Succession Planning",
  ];

  /// Billing address
  const [Bill_Street, set_Bill_Street] = useState("");
  const [Bill_Subrurb, set_Bill_Subrurb] = useState("");
  const [Bill_Country, set_Bill_Country] = useState("");
  const [Bill_State, set_Bill_State] = useState("");
  const [Bill_Postcode, set_Bill_Postcode] = useState("");

  //Validation variable
  const [firstName_ERR, set_firstName_ERR] = useState(false);
  const [lastName_ERR, set_lastName_ERR] = useState(false);
  const [Street_ERR, set_Street_ERR] = useState(false);
  const [Suburb_ERR, set_Suburb_ERR] = useState(false);
  const [Country_ERR, set_Country_ERR] = useState(false);
  const [State_ERR, set_State_ERR] = useState(false);
  const [Zip_ERR, set_Zip_ERR] = useState(false);

  /***
   * Error message
   */
  const [SuccessMessage, setSuccessMessage] = useState(undefined);
  const [ErrorMessage, setErrorMessage] = useState(undefined);
  const [SomethingUpadating, setSomethingUpadating] = useState(false);

  /***
   * get Access token from user detail
   */
  //const UserToken = useState(props.UpdateloginUserDetail);

  /***
   * get user addreess from shopify account
   */

  /***
   * Save data to state
   */
  useEffect(() => {
    if (props.UpdateloginUserDetail !== undefined && props.UpdateloginUserDetail !== null) {

      setfirstName(props.UpdateloginUserDetail.firstName);
      setlastName(props.UpdateloginUserDetail.lastName);
      setPhone(props.UpdateloginUserDetail.phone);

      setemailAddress(props.UpdateloginUserDetail.email);
      setUserToken(props.UpdateloginUserDetail.accessToken);

      // FetchUserDateFromDatabase(props.UpdateloginUserDetail.email, props.UpdateloginUserDetail.lastName, props.UpdateloginUserDetail.accessToken);

    }
  }, [props.UpdateloginUserDetail]);


  useEffect(() => {
    if (userToken === undefined || userToken === null || userToken === "") return;
    //console.log("userToken", userToken);
    FetchUserDateFromDatabase();
  }, [userToken]);



  const FetchUserDateFromDatabase = async () => {
    if (emailAddress === null || emailAddress === "") return;
    try {
      const api_URL = props.EngineURL + "profile/get_profile.php";
      const response = await axios.post(api_URL,
        { contact_id: emailAddress },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
        }
      );

      /***
       * Assign data to State
       */
      if (response.status === 200 && response.data.status === 200) {
        var data = response.data.data[0];
        setyourReferalCode(data.referal_code);
        SetUserSelectedPractice((data.practice_areas !== null) & (data.practice_areas !== "") ? data.practice_areas.split("|") : []);
      } else {
        //(response.data.error);
      }
    } catch (error) {
      console.log(error);
    }

    try {
      setCpdMixLoading(true); // ← add this

      const api_URL1 = props.EngineURL + "salesforce-query/checkout/leo_cpd_mix.php";
      const response1 = await axios.post(api_URL1,
        {
          contact_id: emailAddress,
          user_lname: lastName,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
        }
      );

      /***
       * Assign data to State
       */
      if (response1.status === 200) {
        setTotalOrder(response1.data.total_programs ?? "0");
        setTotalCPDpoints(response1.data.total_cpd_points ?? "0");
        set_PS_points(response1.data.total_ps ?? "0");
        set_PM_points(response1.data.total_pm ?? "0");
        set_SL_points(response1.data.total_sl ?? "0");
        set_EP_points(response1.data.total_ep ?? "0");
      } else {
        // console.log(response1.data.error);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setCpdMixLoading(false); // ← always clears — even on error
    }

    try {

      const api_URL2 = props.EngineURL + "create-account/get_customer.php";
      const formData = new URLSearchParams();
      formData.append("contact_id", emailAddress);
      //console.log("get_customer", userToken);
      const response2 = await axios.post(api_URL2, formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${userToken}`, // Replace `yourToken` with your actual token variable
        },
      });

      /***
       * Assign data to State
       */
      if ((response2.status === 200) & (response2.data.code === 200)) {
        var data2 = response2.data.data;
        setCompany(data2.defaultAddress.company);
        set_Bill_Street(data2.defaultAddress.address1);
        set_Bill_State(stateMap[data2.defaultAddress.province] ?? data2.defaultAddress.province);
        set_Bill_Country(data2.defaultAddress.country);
        set_Bill_Subrurb(data2.defaultAddress.city);
        set_Bill_Postcode(data2.defaultAddress.zip);
        setAddressID(data2.defaultAddress.id);
        setCustomerID(data2.id);
        setfirstName(data2.firstName);
        setlastName(data2.lastName);
        setPhone(data2.phone);
      } else {
        // console.log(response1.data.error);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (userToken === undefined || userToken === null || userToken === "") return;
    FetchUserDateFromDatabase();
  }, [userToken]);

  const handleSubmit = (event) => {
    setSuccessMessage(undefined);
    setErrorMessage(undefined);
    setSomethingUpadating(false);

    event.preventDefault();
    var firstName_ERR_var = true;
    var lastName_ERR_var = true;
    var Phone_ERR_var = true;
    var Street_ERR_var = true;
    var Suburb_ERR_var = true;
    var Country_ERR_var = true;
    var State_ERR_var = true;
    var Zip_ERR_var = true;

    set_firstName_ERR(false);
    set_lastName_ERR(false);
    set_Street_ERR(false);
    set_Suburb_ERR(false);
    set_Suburb_ERR(false);
    set_Country_ERR(false);
    set_State_ERR(false);
    set_Zip_ERR(false);

    if (!firstName) {
      set_firstName_ERR(true);
      firstName_ERR_var = false;
    }

    if (!lastName) {
      set_lastName_ERR(true);
      lastName_ERR_var = false;
    }

    if (!Phone) {
      Phone_ERR_var = false;
    }
    if (Phone && !isValidPhoneNumber(Phone)) {
      Phone_ERR_var = false;
    }

    if (!Bill_Street) {
      set_Street_ERR(true);
      Street_ERR_var = false;
    }

    if (!Bill_Subrurb) {
      set_Suburb_ERR(true);
      Suburb_ERR_var = false;
    }

    if (!Bill_Country) {
      set_Country_ERR(true);
      Country_ERR_var = false;
    }

    if (!Bill_State) {
      set_State_ERR(true);
      State_ERR_var = false;
    }

    if (!Bill_Postcode) {
      set_Zip_ERR(true);
      Zip_ERR_var = false;
    }

    if (
      firstName_ERR_var &&
      lastName_ERR_var &&
      Phone_ERR_var &&
      Street_ERR_var &&
      Suburb_ERR_var &&
      Country_ERR_var &&
      State_ERR_var &&
      Zip_ERR_var
    ) {
      setSomethingUpadating(true);
      setSuccessMessage(undefined);

      try {
        const api_URL = props.EngineURL + "create-account/update_customer.php";
        const formData = new URLSearchParams();
        formData.append("id", CustomerID);
        formData.append("firstName", firstName);
        formData.append("lastName", lastName);
        formData.append("email", emailAddress);
        formData.append("contact_id", emailAddress);
        formData.append("phone", Phone);
        formData.append("company", Company);
        formData.append("address_id", AddressID);
        formData.append("address1", Bill_Street);
        formData.append("city", Bill_Subrurb);
        formData.append("province", Bill_State);
        formData.append("country", Bill_Country);
        formData.append("zip", Bill_Postcode);
        console.log("update_customer", userToken);
        let UpdateCustomer = axios
          .post(api_URL, formData, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${userToken}`, // Replace `yourToken` with your actual token variable
            },
          })
          .then(function (response) {
            if (response.status === 200 && response.data.code === 200) {
              setSomethingUpadating(false);
              setSuccessMessage("Profile updated successfully");
            } else {
              setSomethingUpadating(false);
              setErrorMessage("Profile not updated, please try again later");
            }
          })
          .catch(function (error) {
            setSomethingUpadating(false);
            setErrorMessage("Profile not updated, please try again later");
          });
      } catch (error) {
        setSomethingUpadating(false);
        setErrorMessage("Profile not updated, please try again later");
      }
    }
    // No general "Fields are required!" banner — each field shows its own
    // inline validation message (Street is required, etc.).
  };

  const doLogout = () => {
    axios
      .post(
        props.EngineURL + "create-account/2fa/delete_2fa.php",
        {
          email: props.UpdateloginUserDetail.email,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`, // Replace `yourToken` with your actual token variable
          },
        }
      )
      .then(function (response) {
        localStorage.removeItem("userDetail");
        localStorage.setItem("isLoggedin", false);
        localStorage.removeItem("checkout_token");
        localStorage.removeItem("thank_you_image");
        localStorage.removeItem("checkout_id");
        localStorage.removeItem("cart_session");
        localStorage.removeItem("create_account_detail");
        localStorage.removeItem("cart_session_sku");
        localStorage.removeItem("isLoggedin");
        localStorage.removeItem("was_book");
        localStorage.removeItem("wishlist_item");
        window.location.href = "/";
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  /****
   * Update Practice area to account
   */
  const [UserSelectedPractice, SetUserSelectedPractice] = useState([]);

  const ManageUserSelectionFORpractice = (data) => {
    let UserSelectedPractice_ = UserSelectedPractice;
    if (UserSelectedPractice_.includes(data)) {
      SetUserSelectedPractice([...removeItemOnce(UserSelectedPractice_, data)]);
    } else {
      SetUserSelectedPractice((oldArray) => [...oldArray, data]);
    }
  };

  const removeItemOnce = (arr, value) => {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  };

  const UpdatePracticeArea = () => {
    setSomethingUpadating(true);
    setSuccessMessage(undefined);
    setErrorMessage(undefined);

    // Keep only values that are genuinely valid practice areas
    const CleanedSelectedPractice = PracticeArea.filter((area) =>
      UserSelectedPractice.includes(area)
    );

    SetUserSelectedPractice(CleanedSelectedPractice); // re-init state to the cleaned set

    axios
      .post(
        props.EngineURL + "profile/update_profile.php",
        { contact_id: emailAddress, practice_areas: UserSelectedPractice.join("|") },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`, // Replace `yourToken` with your actual token variable
          },
        }
      )
      .then(function (response) {
        if (response.status === 200 && response.data.status === 200) {
          setSuccessMessage(response.data.message);
        } else {
          setErrorMessage(response.data.error);
        }
        setSomethingUpadating(false);
      })
      .catch(function (error) {
        setErrorMessage(error);
        setSomethingUpadating(false);
      });
  };

  const StateOPtion = [
    { label: "Western Australia", value: "WA" },
    { label: "Queensland", value: "QLD" },
    { label: "South Australia", value: "SA" },
    { label: "New South Wales", value: "NSW" },
    { label: "Tasmania", value: "TAS" },
    { label: "Victoria", value: "VIC" },
    { label: "Australian Capital Territory", value: "ACT" },
  ];

  const getLabel = (optionList, selected) => {
    var label = "";
    optionList.map((value) => {
      if (value.value === selected) {
        label = value.label;
      }
    });
    // console.log(label);
    return label;
  };

  const [cdp_point_popup, set_cpd_point_popup] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const location = useLocation();

  const routeLabels = {
    'admin-profile': 'My Profile',
    'admin-my-events': 'Upcoming Events',
    'admin-my-library': 'My Digital Library',
    'admin-cpd-points': 'CPD Points',
    'my-wishlist': 'Bookmarks',
    'admin-orders': 'Billing History',
  };
  const activeLabel = routeLabels[location.pathname.replace('/', '')] || 'Menu';

  return (
    <>
      {/* Skeleton CSS — scoped to this component */}
      <style>{`
        .cpd_card_skeleton {
            border-radius: 6px;
            background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
            background-size: 200% 100%;
            animation: cpd_shimmer 1.4s infinite;
        }
        .cpd_card_skeleton--count {
            width: 80px;
            height: 48px;
            margin-right: 16px;
        }
        .cpd_card_skeleton--breakdown {
            width: 100%;
            height: 48px;
        }
        @keyframes cpd_shimmer {
            0%   { background-position: 200% 0; }
            100% { background-position: -200% 0; }
        }
    `}</style>
      <div className="admin_page admin_profile">
        <Container>
          <Helmet>
            <title>My Profile | Leo Cussen Centre for Law</title>
          </Helmet>
          {userToken !== undefined ? (
            <div className="admin_wrapper position-relative">
              <div className="admin_details_block">
                <p className="ae-greeting-text">{props.Good},</p>
                <h1 className="ae-greeting-name">{firstName}</h1>
              </div>
              <Row>
                <Col xl={3} lg={4} xs={12} className="d-none d-lg-block">
                  <AdminSidebar doLogout={doLogout} />
                </Col>
                <Col xl={9} lg={8} xs={12}>
                  <div className="admin_right_content_block">
                    <div className="profile_detail_head">
                      <Row xs="auto" className="justify-content-between align-items-center">
                        <Col>
                          <h4 className="m-0 text-dark">Current CPD Year Statistics</h4>
                        </Col>
                        <Col className="d-flex align-items-center ">
                          <div className="manually_add_point d-flex align-items-center" onClick={() => set_cpd_point_popup(true)}>
                            <img src={PlusIconImg} alt="" className="manually_add_icon" /> Manually add points
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <Row className="cpd_stats_row g-2">
                      <Col xs="col-12" sm>
                        <div className="admin_cpd_counts_card d-flex align-items-center">
                          {cpdMixLoading ? (
                            <div className="cpd_card_skeleton cpd_card_skeleton--count" />
                          ) : (
                            <div className="counts">{TotalOrder}</div>
                          )}
                          <h4 className="flex-fill mb-0">CPD Program <br /> Registration</h4>
                        </div>
                      </Col>
                      <Col xs="col-12" sm>
                        <div className="admin_cpd_counts_card d-flex align-items-center">
                          {cpdMixLoading ? (
                            <div className="cpd_card_skeleton cpd_card_skeleton--count" />
                          ) : (
                            <div className="counts">{TotalCPDpoints}</div>
                          )}
                          <h4 className="flex-fill mb-0">Total CPD Points</h4>
                        </div>
                      </Col>
                      <Col xs="col-12" sm>
                        <div className="admin_cpd_counts_card d-flex align-items-center">
                          {cpdMixLoading ? (
                            <div className="cpd_card_skeleton cpd_card_skeleton--breakdown" />
                          ) : (
                            <ul className="d-flex list-unstyled mb-0 w-100 justify-content-between">
                              <li className="text-center">
                                <div className="count-cpd">{PS_points}</div>
                                <span className="ps_cpd">
                                  <img src={ps} alt="Professional Skills" title="Professional Skills" className="cpd_topic_icon" />
                                </span>
                              </li>
                              <li className="text-center">
                                <div className="count-cpd">{PM_points}</div>
                                <span className="pm_cpd">
                                  <img src={pm} alt="Practice Management & Business Skills" title="Practice Management & Business Skills" className="cpd_topic_icon" />
                                </span>
                              </li>
                              <li className="text-center">
                                <div className="count-cpd">{SL_points}</div>
                                <span className="sl_cpd">
                                  <img src={sl} alt="Substantive Law" title="Substantive Law" className="cpd_topic_icon" />
                                </span>
                              </li>
                              <li className="text-center">
                                <div className="count-cpd">{EP_points}</div>
                                <span className="ep_cpd">
                                  <img src={ep} alt="Ethics & Professional Responsibility" title="Ethics & Professional Responsibility" className="cpd_topic_icon" />
                                </span>
                              </li>
                            </ul>
                          )}
                        </div>
                      </Col>
                    </Row>
                    <div className="profile_detail_head">
                      <Row xs="auto" className="justify-content-between align-items-center">
                        <Col>
                          <h4 className="m-0 text-dark">My Profile</h4>
                        </Col>
                        <Col className="d-flex align-items-center">
                          <div className="edit_profile d-flex align-items-center" onClick={() => setEditProfile(true)}>
                            <img src={EditIconImg} alt="" className="edit_profile_icon" /> Edit profile
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className={EditProfile ? "profile_detail  d-none" : "profile_detail"}>
                      <div className="profile_detail_content">
                        <ul className="list-unstyled">
                          <li>
                            <span>Name:</span> {firstName} {lastName}
                          </li>
                          <li>
                            <span>Organisation Name:</span>
                            {Company}
                          </li>
                          <li>
                            <span>Email:</span>
                            {emailAddress}
                          </li>
                          {yourReferalCode !== null && yourReferalCode !== "" ? (
                            <li>
                              <span>Your Referral Code:</span> {yourReferalCode}
                            </li>
                          ) : null}
                        </ul>
                      </div>
                      <div className="practice_area_interests">
                        <h4 className="text-dark mb-1">Practice Area Interests</h4>
                        <p>Choose the practice areas that interest you to receive latest offers</p>
                        <Row xs="1" md="2" className="practice_checkbox_row">
                          {PracticeArea.map((val, index) => {
                            return (
                              <Col key={index}>
                                <Form.Check
                                  label={val}
                                  value={val}
                                  onChange={(e) => ManageUserSelectionFORpractice(e.target.value)}
                                  data-checked={UserSelectedPractice.includes(val)}
                                  checked={UserSelectedPractice.includes(val)}
                                />
                              </Col>
                            );
                          })}
                        </Row>
                      </div>

                      <Button type="button" onClick={UpdatePracticeArea} disabled={SomethingUpadating == true ? true : false} className="mb-3 ae-update-btn">
                        {SomethingUpadating == true ? 'Updating...' : 'Update'}
                      </Button>
                      {ErrorMessage !== undefined ? <Alert variant="danger">{ErrorMessage}</Alert> : ""}

                      {SuccessMessage !== undefined ? <Alert variant="success">{SuccessMessage}</Alert> : ""}
                    </div>
                    <Form validated={validated} onSubmit={handleSubmit} className={`profile_edit_form ${EditProfile ? "" : "d-none"}`}>
                      <div className="profile_card profile_details_card shadow bg-white rounded-2">
                        <div className="profile_section profile_personal_details">
                          <div className="profile_card_content">
                            <h4 className="display-4 text-primary">My Details</h4>
                            <Row>
                              <Form.Group as={Col} md="6" xs="12" controlId="validationCustom01" className="form-group">
                                <Form.Label>First name</Form.Label>
                                <Form.Control
                                  value={firstName}
                                  onChange={(e) => { setfirstName(e.target.value); if (firstName_ERR) set_firstName_ERR(false); }}
                                  type="text"
                                  placeholder="First name*"
                                  className={firstName_ERR ? "form-error" : ""}
                                  name="firstName"
                                />
                                {firstName_ERR && <span className="field-error-msg">First name is required</span>}
                              </Form.Group>
                              <Form.Group as={Col} md="6" xs="12" controlId="validationCustom02" className="form-group">
                                <Form.Label>Last name</Form.Label>
                                <Form.Control
                                  value={lastName}
                                  onChange={(e) => { setlastName(e.target.value); if (lastName_ERR) set_lastName_ERR(false); }}
                                  type="text"
                                  className={lastName_ERR ? "form-error" : ""}
                                  placeholder="Last name*"
                                  name="lastName"
                                />
                                {lastName_ERR && <span className="field-error-msg">Last name is required</span>}
                              </Form.Group>
                              <Form.Group as={Col} md="6" controlId="validationCustomemail" className="form-group">
                                <Form.Label>Email Address</Form.Label>
                                <InputGroup hasValidation>
                                  <Form.Control
                                    type="email"
                                    value={emailAddress}
                                    placeholder="Your email*"
                                    aria-describedby="inputGroupPrepend"
                                    name="email"
                                    readOnly
                                  />
                                  <Form.Control.Feedback type="invalid">Wrong Email Address.</Form.Control.Feedback>
                                </InputGroup>
                              </Form.Group>
                              <Form.Group as={Col} md="6" controlId="validationCustomCompany" className="form-group">
                                <Form.Label>Company</Form.Label>
                                <Form.Control value={Company} onChange={(e) => setCompany(e.target.value)} type="text" placeholder="Company" />
                                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                              </Form.Group>
                              <Form.Group as={Col} md="6" controlId="validationCustomMobile" className="form-group">
                                <Form.Label>Phone number</Form.Label>
                                <PhoneInput
                                  name="Mobile"
                                  international
                                  defaultCountry="AU"
                                  placeholder="0412 345 678"
                                  value={Phone}
                                  onChange={setPhone}
                                />
                              </Form.Group>
                            </Row>
                          </div>
                        </div>
                        <div className="profile_section profile_billing_address_details">
                          <div className="profile_card_content">
                            <h4 className="display-4 text-primary">Address</h4>
                            <Row>
                              <Form.Group as={Col} md="6" xs="12" controlId="validationCustom03" className="form-group">
                                <Form.Label>Street</Form.Label>
                                <Form.Control
                                  type="text"
                                  className={Street_ERR ? "form-error" : ""}
                                  value={Bill_Street}
                                  onChange={(e) => { set_Bill_Street(e.target.value); if (Street_ERR) set_Street_ERR(false); }}
                                  placeholder="Street*"
                                />
                                {Street_ERR && <span className="field-error-msg">Street is required</span>}
                              </Form.Group>
                              <Form.Group as={Col} md="6" xs="12" controlId="validationCustom04" className="form-group">
                                <Form.Label>Suburb / city</Form.Label>
                                <Form.Control
                                  type="text"
                                  className={Suburb_ERR ? "form-error" : ""}
                                  placeholder="Suburb*"
                                  value={Bill_Subrurb}
                                  onChange={(e) => { set_Bill_Subrurb(e.target.value); if (Suburb_ERR) set_Suburb_ERR(false); }}
                                />
                                {Suburb_ERR && <span className="field-error-msg">Suburb / city is required</span>}
                              </Form.Group>
                              <Form.Group as={Col} md="6" xs="12" controlId="validationCustom06" className="form-group">
                                <Form.Label>State</Form.Label>
                                <Form.Select
                                  className={State_ERR ? "form-error form-control" : "form-control"}
                                  value={Bill_State}
                                  onChange={(e) => { set_Bill_State(e.target.value); if (State_ERR && e.target.value) set_State_ERR(false); }}
                                >
                                  <option value="">State*</option>
                                  <option value="VIC">Victoria</option>
                                  <option value="NSW">New South Wales</option>
                                  <option value="QLD">Queensland</option>
                                  <option value="TAS">Tasmania</option>
                                  <option value="WA">Western Australia</option>
                                  <option value="SA">South Australia</option>
                                </Form.Select>
                                {State_ERR && <span className="field-error-msg">Please select a state</span>}
                              </Form.Group>
                              <Form.Group as={Col} md="6" xs="12" controlId="validationCustom05" className="form-group">
                                <Form.Label>Country</Form.Label>
                                <Form.Control
                                  type="text"
                                  className={Country_ERR ? "form-error" : ""}
                                  placeholder="Country*"
                                  value={Bill_Country}
                                  onChange={(e) => { set_Bill_Country(e.target.value); if (Country_ERR) set_Country_ERR(false); }}
                                />
                                {Country_ERR && <span className="field-error-msg">Country is required</span>}
                              </Form.Group>
                              <Form.Group as={Col} md="6" xs="12" controlId="validationCustom07" className="form-group">
                                <Form.Label>Post Code</Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder="Post code*"
                                  className={Zip_ERR ? "form-error" : ""}
                                  value={Bill_Postcode}
                                  onChange={(e) => { set_Bill_Postcode(e.target.value); if (Zip_ERR) set_Zip_ERR(false); }}
                                />
                                {Zip_ERR && <span className="field-error-msg">Post code is required</span>}
                              </Form.Group>
                            </Row>
                          </div>
                        </div>
                      </div>

                      <div className="profile_cta text-center d-flex flex-wrap align-items-center justify-content-center">
                        {ErrorMessage !== undefined ? <Alert variant="danger">{ErrorMessage}</Alert> : ""}
                        {SuccessMessage !== undefined ? <Alert variant="success">{SuccessMessage}</Alert> : ""}
                        {SomethingUpadating === true ? <Alert variant="primary">Upadating....</Alert> : ""}

                        <Button type="submit" className="profile_cta_save" disabled={SomethingUpadating}>
                          Save
                        </Button>
                        <Button type="button" className="btn-cancle" onClick={() => setEditProfile(false)}>
                          Cancel
                        </Button>
                      </div>
                    </Form>
                  </div>
                </Col>
              </Row >
            </div >
          ) : (
            <div className="text-center">
              <h3>Please login to access My profile section</h3>
              <a onClick={() => props.ShowLoginPopup_()} className="btn btn-primary rounded-pill m-0 stest">
                {" "}
                Login
              </a>
            </div>
          )}
        </Container >
        <ManuallyCPD EngineURL={props.EngineURL} cdp_point_popup={cdp_point_popup} set_cpd_point_popup={set_cpd_point_popup} email={emailAddress} userToken={userToken} RefreshData={FetchUserDateFromDatabase} />
      </div >
      <div className={`admin_sidebar_mobile${mobileSidebarOpen ? ' sidebar-open' : ''}`}>
        <div className="admin_sidebar_drawer">
          <AdminSidebar doLogout={doLogout} />
        </div>
        <button
          className="admin_sidebar_trigger"
          onClick={() => setMobileSidebarOpen(!mobileSidebarOpen)}
          aria-expanded={mobileSidebarOpen}
        >
          <span className="admin_sidebar_trigger_label">{activeLabel}</span>
          <svg className="admin_sidebar_trigger_dots" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="5" r="1.5" fill="#1C1C1C" />
            <circle cx="12" cy="12" r="1.5" fill="#1C1C1C" />
            <circle cx="12" cy="19" r="1.5" fill="#1C1C1C" />
          </svg>
        </button>
      </div>
    </>
  );
};
